// Web checkout = backend Paystack flow (initialize → Paystack hosted page → /payment/callback → backend verify).
// When the backend has no Paystack key it returns a TEST MODE checkout instead (no authorization_url).
export const callbackUrl = () => `${window.location.origin}/payment/callback`;

/** Redirects to Paystack when the backend returned an authorization_url. Returns true if redirecting. */
export function redirectToPaystack(res) {
  const url = res?.checkout?.authorization_url;
  if (!url) return false;
  window.location.assign(url);
  return true;
}

export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL;
export const supportMailto = (subject = "LOVE NET support") => `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;
